"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.moveUsersToGroup = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const ActionTypes = require("../../actionTypes/customer/members");
const Actions = require("../../actions/customer/members");
function moveUsersToGroup(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.MOVE_USER_TO_USER_GROUP_SAVE_REQUEST), (0, operators_1.mergeMap)((request) => {
        return ajax({
            headers: {
                'Content-Type': 'application/json',
                Authorization: getToken()
            },
            method: 'POST',
            body: {
                users: request.payload.users,
                newGroup: request.payload.group.uuid
            },
            url: `${baseUrl}api/admin/user/move-users`
        }).pipe((0, operators_1.mergeMap)(() => {
            const customerId = store.value.customer.wizard.customerId;
            const actions = customerId
                ? [
                    Actions.moveUsersToGroupSaveSuccess(),
                    Actions.UsergroupList.fetchRequest('CUSTOMER_MEMBERS', customerId)
                ]
                : [Actions.moveUsersToGroupSaveSuccess()];
            return (0, rxjs_1.merge)((0, rxjs_1.of)(...actions), (0, rxjs_1.of)(Actions.toggleMoveUserToGroup(false)).pipe((0, operators_1.delay)(2000)));
        }), (0, operators_1.catchError)((e) => (0, rxjs_1.of)(Actions.moveUsersToGroupSaveFailure(e))));
    }));
}
exports.moveUsersToGroup = moveUsersToGroup;
//# sourceMappingURL=members.js.map